/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamFormularSk extends GContentBase<SeznamFormularSkObj> {
        private seznamObj: SeznamFormularSkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamFormularSkObj()); 
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnost",
                contentCaption: "jres:33000671", //RC 33000671 : Formuláře SK
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_fsk}"
                },
                gridSettings: {
                    columnOrder: `nazev,eform_id,eformversion,typ_zarazeni_txt,${this.seznamObj.povolSlozka == true ? "ixs_slo_txt," : ""}${this.seznamObj.povolFormDol == true ? "ixs_fsk_do_txt," : "" }dat_zmena,zmenu_prov_txt`
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamFormularSkObj extends GAdmSeznamBase {
        povolSlozka: boolean;
        povolFormDol: boolean;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailFormularSk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailFormularSk",
                newRecord: isNew,
                ixs_fsk: isNew == true ? null : data.ixs_fsk
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.FormularSk.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_fsk),
                nazev: data["nazev"]
            }
        }
    }
}